import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSquareArrowBottomRight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconSquareArrowBottomRight"><Path fillRule="evenodd" clipRule="evenodd" d="M21 3V10L19 10V5L5 5L5 19H10V21H3L3 3L21 3ZM21 13V21H13V19H17.5858L9.58579 11L11 9.58579L19 17.5858V13H21Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSquareArrowBottomRight;
